import { Link } from "react-router-dom";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logoLightSmallSvg from "../../assets/images/logo-light-small.svg";

const Header = () => {
    const tToggle = () => {
        const body = document.body;
        if (window.screen.width <= 998) {
            body.classList.toggle("sidebar-enable");
        } else {
            body.classList.toggle("vertical-collpsed");
            body.classList.toggle("sidebar-enable");
        }
    }

    return (
        <header id="page-topbar">
            <div className="navbar-header">
                <div className="d-flex">
                    <div className="navbar-brand-box d-lg-none d-md-block">
                        <Link to="/" className="logo logo-light">
                        <span className="logo-sm">
                          <img src={logoLightSmallSvg} alt="" height="19"/>
                        </span>
                        </Link>
                    </div>

                    <button
                        type="button"
                        onClick={() => {
                            tToggle();
                        }}
                        className="btn btn-sm px-3 font-size-16 header-item "
                        id="vertical-menu-btn"
                    >
                        <i className="fa fa-fw fa-bars"/>
                    </button>
                </div>
                <div className="d-flex">
                    <ProfileMenu/>
                </div>
            </div>
        </header>
    );
};

export default Header;
